import { useCallback, useRef } from 'react';
export function useFormEventDispatch(callbacks) {
  const callbacksRef = useRef(callbacks);
  callbacksRef.current = callbacks;
  return useCallback((eventName, instance) => {
    var _cbs$onFormEvent;
    const cbs = callbacksRef.current;
    (_cbs$onFormEvent = cbs.onFormEvent) === null || _cbs$onFormEvent === void 0 || _cbs$onFormEvent.call(cbs, eventName, instance);
    if (eventName === 'onFormReady') {
      if (instance) {
        var _cbs$onFormReady;
        (_cbs$onFormReady = cbs.onFormReady) === null || _cbs$onFormReady === void 0 || _cbs$onFormReady.call(cbs, instance);
      }
    } else {
      var _cbs$eventName;
      (_cbs$eventName = cbs[eventName]) === null || _cbs$eventName === void 0 || _cbs$eventName.call(cbs);
    }
  }, []);
}